import { call, put, select, takeEvery, takeLatest, delay } from 'redux-saga/effects'

export default (prefix, requestFunc, getSelector, itemsPerPage = 10, processingFunc = null) => {
    const LOCAL_STORAGE_PREFIX = `createTableFetcher.${prefix}`
    const _itemsPerPage = Number(localStorage.getItem(`${LOCAL_STORAGE_PREFIX}.itemsPerPage`)) || itemsPerPage    
    const types = {
        TRIGGER: prefix + '/TRIGGER',
        SUCCESS: prefix + '/SUCCESS',
        FAILURE: prefix + '/FAILURE',
        FULFILL: prefix + '/FULFILL',
        SEARCH: prefix + '/SEARCH',
        PAGE_CHANGE: prefix + '/PAGE_CHANGE',
        CHANGE_ITEMS_PER_PAGE: prefix + '/CHANGE_ITEMS_PER_PAGE'
    }

    const actions = {
        trigger: (params = undefined) => ({ type: types.TRIGGER, params }),
        success: (payload) => ({ type: types.SUCCESS, payload }),
        failure: () => ({ type: types.FAILURE }),
        fulfill: () => ({ type: types.FULFILL }),
        search: (searchPhrase = undefined) => ({ type: types.SEARCH, searchPhrase }),
        pageChange: (change) => ({ type: types.PAGE_CHANGE, change }),
        changeitemsPerPage: (count) => ({ type: types.CHANGE_ITEMS_PER_PAGE, count })
    }

    const initialState = {
        loading: false,
        params: {},
        searchPhrase: '',
        page: 1,
        items: [],
        error: null,
        itemsTotal: 0,
        itemsPerPage: _itemsPerPage
    }

    const reducer = (state = initialState, action) => {
        switch (action.type) {
            case types.TRIGGER:
                return {
                    ...state,
                    loading: true,
                    params: action.params ? Object.assign(state.params, action.params) : state.params
                };
            case types.SUCCESS:
                return {
                    ...state,
                    items: action.payload.results,
                    itemsTotal: action.payload.count
                };
            case types.FAILURE:
                return {
                    ...state,
                    error: action.payload,
                };
            case types.FULFILL:
                return {
                    ...state,
                    loading: false,
                };
            case types.SEARCH:
                return {
                    ...state,
                    searchPhrase: action.searchPhrase,
                };
            case types.PAGE_CHANGE:
                return {
                    ...state,
                    page: state.page + action.change,
                };
            case types.CHANGE_ITEMS_PER_PAGE:
                return {
                    ...state,
                    page: 1,
                    itemsPerPage: action.count,
                };
            default:
                return state;
        }
    }

    function* requestWatcherSaga() {
        yield takeEvery(types.TRIGGER, fetchDataFromServer);
        yield takeLatest(types.SEARCH, search);
        yield takeEvery(types.PAGE_CHANGE, pageChange);
        yield takeEvery(types.CHANGE_ITEMS_PER_PAGE, changeItemsPerPage);
    }

    function* fetchDataFromServer() {        
        
        try {
            const state = yield select(getSelector);
            const params = Object.assign({}, state.params, { searchPhrase: state.searchPhrase, page: state.page, itemsPerPage: state.itemsPerPage });
            let payload = yield call(requestFunc, params);
            if(processingFunc)
                payload.results = processingFunc(payload.results);
            yield put(actions.success(payload));
        } catch (error) {
            yield put(actions.failure(error.message));
        } finally {
            yield put(actions.fulfill());
        }
    }

    function* search(action) {
        yield delay(500);
        yield put(actions.trigger())
    }

    function* pageChange(action) {
        yield put(actions.trigger())
    }

    function* changeItemsPerPage(action) {
        localStorage.setItem(`${LOCAL_STORAGE_PREFIX}.itemsPerPage`, action.count)
        yield put(actions.trigger())
    }

    return {
        reducer,
        saga: requestWatcherSaga,
        actions
    }
}